import PropTypes from 'prop-types';
import React from 'react';

import Button from '@component/form/element/button';

const AccountWarning = ({ action, actionText, subtitle, title }) => (
  <div className="accountwarning">
    <h2>{title}</h2>
    <p>{subtitle}</p>
    <Button
      className="accountwarning__action"
      type="inline"
      onClick={action}
      text={actionText}
    />
  </div>
);

AccountWarning.propTypes = {
  action: PropTypes.func,
  actionText: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default AccountWarning;
